import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrowserDetectorService {
  isSafari() {
    const ua = navigator.userAgent;
    const iOS = ua.match(/Macintosh/i) || ua.match(/iPad/i) || ua.match(/iPhone/i);
    const webkit = ua.match(/WebKit/i);
    const iOSSafari = iOS && webkit && !ua.match(/CriOS/i) && !ua.match(/EdgiOS/i) && !ua.match(/Chrome/i) && !ua.match(/Edg/i);
    return iOSSafari;
  }

  /**
   * This method was discovered when no other reliable way was found to detect 32-bit versions of Chrome (user agent, platform, etc.)
   * This attempts to allocate approximately 2GB of memory (32,767 pages * 64 KiB per page)
   * On a 32-bit system, this allocation will likely fail regardless of physical RAM, due to address space limitations
   * On a 64-bit system, it's more likely to succeed, even with less than 2GB of free RAM.
   */
  is64Bit(): boolean | null {
    if (typeof WebAssembly === 'object' && typeof WebAssembly.Memory === 'function') {
      try {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const memory = new WebAssembly.Memory({ initial: 32767 });
        return true; // 64-bit
      } catch (e) {
        return false; // 32-bit or allocation failed
      }
    } else {
      return null; // WebAssembly not supported
    }
  }

  isChrome32Bit() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isChrome = /chrome/.test(userAgent);
    const is32Bit = this.is64Bit() === false;
    return isChrome && is32Bit;
  }
}
